import React from 'react';
import MthlyFeeReg from './Monthly_Fee_Register';
import '../../../CommonCSS/SocietyCSS.css'

const MthlyFeeRegApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Monthly Fee Register</h5>
          </div>
        </div>
        <MthlyFeeReg />
      </div>
    </div >
  );
};

export default MthlyFeeRegApp;
